"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.OutLevel = void 0;
var OutLevel;
(function (OutLevel) {
    OutLevel[OutLevel["Log"] = 0] = "Log";
    OutLevel[OutLevel["Info"] = 1] = "Info";
    OutLevel[OutLevel["Warn"] = 2] = "Warn";
    OutLevel[OutLevel["Error"] = 3] = "Error";
    OutLevel[OutLevel["None"] = 4] = "None";
})(OutLevel = exports.OutLevel || (exports.OutLevel = {}));
var Logger = /** @class */ (function () {
    function Logger() {
        this.outLevel = OutLevel.Warn;
    }
    Logger.prototype.setOutLevel = function (level) {
        this.outLevel = level;
    };
    Logger.prototype.error = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.outLevel <= OutLevel.Error) {
            console.error.apply(console, __spreadArrays([message], optionalParams));
        }
    };
    Logger.prototype.info = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.outLevel <= OutLevel.Info) {
            console.info.apply(console, __spreadArrays([message], optionalParams));
        }
    };
    Logger.prototype.log = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.outLevel <= OutLevel.Log) {
            console.log.apply(console, __spreadArrays([message], optionalParams));
        }
    };
    Logger.prototype.warn = function (message) {
        var optionalParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            optionalParams[_i - 1] = arguments[_i];
        }
        if (this.outLevel <= OutLevel.Warn) {
            console.warn.apply(console, __spreadArrays([message], optionalParams));
        }
    };
    return Logger;
}());
exports.Logger = Logger;
var logger = new Logger();
exports.default = logger;
//# sourceMappingURL=logger.js.map